import { render, staticRenderFns } from "./DelegationOrderReadonlyView.vue?vue&type=template&id=33ba3901&scoped=true&"
import script from "./DelegationOrderReadonlyView.vue?vue&type=script&lang=js&"
export * from "./DelegationOrderReadonlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba3901",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ba3901')) {
      api.createRecord('33ba3901', component.options)
    } else {
      api.reload('33ba3901', component.options)
    }
    module.hot.accept("./DelegationOrderReadonlyView.vue?vue&type=template&id=33ba3901&scoped=true&", function () {
      api.rerender('33ba3901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-order/DelegationOrderReadonlyView.vue"
export default component.exports